window.addEventListener('load', () => {

    const graphSection = document.querySelectorAll('.mod-interactive-map__graph-section');

    if (!graphSection) return;

    class InteractiveMapGraphSection {
        constructor (graphSection) {
            this.graphSection = graphSection;

            this.mediaQueryValue = 340;

            this.graphImages = [];
            this.graphTitle;
            this.mapContainer;

            this.regionSelected;
            this.graphText;

            this.resizing;
            
            this.init(graphSection);

            this.previouslySelectedGraph;
        }

        init = (graphSection) => {
            this.graphTitle = graphSection.querySelector('.mod-interactive-map__title');

            //NEED TO SET THE TEMPLATE OF FOR TITLE
            if (this.graphTitle) this.graphText = this.graphTitle.innerText;

            this.mapContainer = graphSection.closest('.mod-interactive-map');
            this.initObservation(this.mapContainer);
        }

        initObservation = (mapContainer) => {
            //OBSERVES EACH MAP ON PAGE FOR CHANGES IN THE DATA-SELECTED-REGION ATTRIBUTE
            const observer = new MutationObserver((mutations) => {
                mutations.forEach((mutation) => {
                    if (mutation.type === 'attributes' && mutation.attributeName === 'data-selected-region') {
                        this.regionSelected = mapContainer.getAttribute('data-selected-region');
                        const newGraph = this.setSelectedGraphToVisible(this.regionSelected);
                        if (newGraph) {
                            this.setGraphTitle(this.regionSelected);
                        } else {
                            this.removeGraphTitle();

                        }
                    }
                });
            });

            observer.observe(mapContainer, {attributes: true});
        }

        regionParser = (region) => {
            return region.replaceAll('_', ' ');
        }

        setGraphTitle = (region) => {
            this.graphTitle.innerHTML = `${this.regionParser(region)} ${this.graphText}`;
            this.graphTitle.style.display = 'block';
        }

        removeGraphTitle = () => {
            this.graphTitle.style.display = 'none';
        }

        checkGraphSizing = () => {
            return this.mapContainer.offsetWidth > this.mediaQueryValue;
        }
        

        setSelectedGraphToVisible = (regionSelected) => {
            let queryString;
            //WORKS AS MEDIA QUERY
            if (this.checkGraphSizing()) {
                queryString = `${regionSelected}--desktop`;
            } else {
                queryString = `${regionSelected}--mobile`;
            }

            const selectedGraph = document.getElementById(`${queryString}`);
            if (selectedGraph) selectedGraph.style.display = 'block';
            
            if (selectedGraph !== this.previouslySelectedGraph) this.hidePreviousGraph(selectedGraph);
            return selectedGraph;
        }

        hidePreviousGraph = (selectedGraph) => {
            if (this.previouslySelectedGraph) this.previouslySelectedGraph.style.display = 'none';
            this.previouslySelectedGraph = selectedGraph;
        }


        debounce = (func, delay) => {
            //DEBOUNCE FUNCTION FOR RESIZE
            let timeoutId;
            return function (...args) {
                clearTimeout(timeoutId);
                timeoutId = setTimeout(() => {
                    func(...args);
                }, delay);
            };
        }

        debounceResizeHandler = this.debounce(() => {
            //RECALC THE TOOLTIP POSITION ONCE RESIZE IS DONE
            this.setSelectedGraphToVisible(this.regionSelected)
        }, 200);
    }


    const graphInstances = [];
    graphSection.forEach(graph => {
        const graphInstance = new InteractiveMapGraphSection(graph);
        graphInstances.push(graphInstance);
    });

    window.addEventListener('resize', () => {
        graphInstances.forEach(graphInstance => {
            graphInstance.debounceResizeHandler();
        });
    });
});